export type RelatedDataKeys = typeof RELATED_DATA_KEYS[keyof typeof RELATED_DATA_KEYS];

export const RELATED_DATA_KEYS = {
  fly: 'fly',
  stay: 'stay',
  personal: 'personal',  
  general: 'general',
  travel: 'travel',
} as const;